import axios from 'axios';
import Cookies from 'js-cookie'

const BASE_URI = process.env.API_BASE_URI;

class AuthService {
    login(user) {
        let data = {
            'email': user.username,
            'password': user.password,
            'remember': user.remember,
            'isOwnner': true
        };
        return axios.post(BASE_URI + '/v1/auth/login', data).then(response => {
            console.log(response, 'response');

            if (!response.data || !response.data.data || !response.data.data.access_token) {
                const message = (response.data && response.data.message) || 'Login failed. Please try again.';
                return Promise.reject({ message });
            }

            Cookies.set('ownerToken', response.data.data.access_token, { domain: '.' + process.env.OWNER_DOMAIN })

            if (data.remember) {
                var encodepassword = window.btoa(data.password);
                Cookies.set('owner_login_email', data.email, {expires: 30, domain: '.' + process.env.OWNER_DOMAIN });
                Cookies.set('owner_login_password', encodepassword, {expires: 30, domain: '.' + process.env.OWNER_DOMAIN });
            } else {
                Cookies.remove('owner_login_email', { domain: '.' + process.env.OWNER_DOMAIN });
                Cookies.remove('owner_login_password', { domain: '.' + process.env.OWNER_DOMAIN });
            }

            return response.data;
        });
    }
    logout() {
        Cookies.remove('ownerToken', { domain: '.' + process.env.OWNER_DOMAIN })
    }
}

export default new AuthService()



// WEBPACK FOOTER //
// ./src/services/auth.service.js